import { Form, Input, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import AppStore from "../../../../../stores/User/AppStore";
const { Option } = Select;

export interface ProjectEditDialogProps {
  visible: boolean;
  id: number;
  otherTag: { id: string; name: string }[];
  industryTag: { id: string; name: string };
  close: () => void;
  submit: (id: string, industryTag: string, otherTagList: string[]) => void;
}

const ProjectEditDialog: React.FC<ProjectEditDialogProps> = (props) => {
  const [form] = Form.useForm();
  const { id, visible, otherTag, industryTag, close, submit } = props;
  useEffect(() => {
    visible &&
      form.setFieldsValue({
        otherTagList: Array.isArray(otherTag)
          ? otherTag.map((item) => item?.name)
          : [],
        industryTag: industryTag?.name,
      });
  }, [visible]);

  const onSubmit = () => {
    const { industryTag, otherTagList } = form.getFieldsValue();

    const industryArr = AppStore.industryTag.filter(
      (item) => item.name === industryTag
    )[0]?.id;
    const otherArr = otherTagList.map(
      (item: any) => AppStore.otherTag.filter((i) => i.name === item)[0].id
    );

    submit(
      String(id),
      industryArr ? String(industryArr) : "",
      otherArr.length ? otherArr : []
    );

    // form.resetFields();
    props.close();
  };
  return (
    <Modal
      title="编辑标签"
      visible={visible}
      onCancel={close}
      onOk={onSubmit}
      okText="确认"
      cancelText="取消"
    >
      <Form form={form}>
        <Form.Item label="行业标签" name="industryTag">
          <Select
            allowClear
            size="middle"
            placeholder="请选择行业标签"
            key={AppStore.industryTag.map((item) => item.id)[0]}
            defaultValue={industryTag?.name}
            style={{ width: "100%" }}
          >
            {AppStore.industryTag.map((item) => (
              <Option key={item.name}>{item.name} </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="其他标签" name="otherTagList">
          <Select
            mode="multiple"
            size="middle"
            placeholder="请选择其他标签"
            key={AppStore.otherTag.map((item) => item.id)[0]}
            defaultValue={
              Array.isArray(otherTag) ? otherTag.map((item) => item?.name) : []
            }
            onChange={(v) => console.log(v)}
            style={{ width: "100%" }}
          >
            {AppStore.otherTag.map((item) => (
              <Option key={item.name}>{item.name} </Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default observer(ProjectEditDialog);
